import {
  Callback,
  createEventEmitter,
  VoidCallback,
} from './framework/event-emitter';
import { CookieConsentType } from './models/cookie-consent-type.enum';
import { ConcurrencyOption } from './types/concurrency-option.type';
import { QualityOption } from './types/quality-option.type';

type Events = {
  error: Callback<{ error: Error; errorPayload?: any }>;
  warn: Callback<{ message: Error | string }>;
  info: Callback<{ message: string }>;
  open: Callback<{ files: FileList }>;
  convert: Callback<{
    files: FileList;
    quality: QualityOption;
    concurrency: ConcurrencyOption;
  }>;
  download: Callback<{ blob: Blob; filename: string }>;
  'progress-info': Callback<{ text: string }>;
  'add-to-zip': Callback<{ blob: Blob; filename: string }>;
  'added-to-zip': Callback<{ filename: string; elapsed: number }>;
  'generate-zip': VoidCallback;
  'generated-zip': VoidCallback;
  'download-zip': VoidCallback;
  'progress-eta': Callback<{ seconds: number }>;
  progress: Callback<{ percent: number }>;
  'set-quality': Callback<{ quality: QualityOption }>;
  'set-concurrency': Callback<{ concurrency: ConcurrencyOption }>;
  'set-consent': Callback<{ consent: CookieConsentType[] }>;
  'consent-set': VoidCallback;
  'add-consent': Callback<{ consent: CookieConsentType }>;
  'remove-consent': Callback<{ consent: CookieConsentType }>;
  'toggle-consent': Callback<{ consent: CookieConsentType }>;
  'convert-finished': VoidCallback;
  'downloaded-zip': Callback<{ type: 'zip' }>;
  'downloaded-file': Callback<{ type: 'file' }>;
  'download-file': VoidCallback;
  'redownload-zip': VoidCallback;
  'progress-close': VoidCallback;
  'convert-finished-without-errors': Callback<{ files: FileList | File[] }>;
  'convert-finished-with-errors': Callback<{
    numberOfFailedFiles: number;
    files: FileList | File[];
  }>;
  'convert-more': VoidCallback;
};

export const events = createEventEmitter<Events>();
